import { ListingCategory, ListingStatus, ListingType } from '~/api/listings';

export const categoryOptions: { label: string; value: ListingCategory }[] = [
  { label: 'Furniture', value: 'furniture' },
  { label: 'Electronics', value: 'electronics' },
  { label: 'Clothing', value: 'clothing' },
  { label: 'Home goods', value: 'home_goods' },
  { label: 'Toys & kids', value: 'toys_kids' },
  { label: 'Books', value: 'books' },
  { label: 'Sports', value: 'sports' },
  { label: 'Plants', value: 'plants' },
  { label: 'Other', value: 'other' }
];

export const typeOptions: { label: string; value: ListingType }[] = [
  { label: 'For sale', value: 'sale' },
  { label: 'Free', value: 'free' },
  { label: 'In search of', value: 'iso' }
];

export const statusOptions: { label: string; value: ListingStatus }[] = [
  { label: 'Active', value: 'active' },
  { label: 'Sold', value: 'sold' },
  { label: 'Given away', value: 'gone' },
  { label: 'Found', value: 'found' },
  { label: 'Removed', value: 'removed' }
];

const labelFor = <T extends string>(
  options: { label: string; value: T }[],
  value: T
): string => options.find((option) => option.value === value)?.label ?? value;

export const categoryLabel = (value: ListingCategory) =>
  labelFor(categoryOptions, value);
export const typeLabel = (value: ListingType) => labelFor(typeOptions, value);
export const statusLabel = (value: ListingStatus) =>
  labelFor(statusOptions, value);

// Narrows a select value to one of `options`, or undefined for "all".
export const toOption = <T extends string>(
  options: { label: string; value: T }[],
  value?: string
): T | undefined => options.find((option) => option.value === value)?.value;

// Money is integer cents. ISO posts have no price.
export const formatPrice = (priceCents: number | null): string => {
  if (priceCents === null) return '—';
  if (priceCents === 0) return 'Free';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: priceCents % 100 ? 2 : 0
  }).format(priceCents / 100);
};
